import type { TReducerAction } from './actions';
import { ActionTypes } from './actions';
import type { TState } from './state';

export function reducer<
    TExportData extends { [key: string]: unknown } = { [key: string]: unknown }
>(
    state: TState<TExportData>,
    action: TReducerAction<TExportData>
): TState<TExportData> {
    switch (action.type) {
        case ActionTypes.SET_STATE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}
